import { Helmet } from "react-helmet";
import bm from "../../components/100-board-members/BoardMembers100.module.scss";
import Styles from "./PrivacyPolicy.module.scss";

export default function PrivacyPolicy() {
  return (
    <div className={bm["page-wrapper"]}>
      <Helmet>
        <title>Privacy Statement | Iron Lady</title>
        <meta
          name="description"
          content="Iron Lady privacy statement: how we collect, use, disclose, and protect your personal information."
        />
        <link rel="canonical" href="https://iamironlady.com/privacy-policy" />
      </Helmet>

      <section className={`${bm.breakthrough} ${Styles.privacyMain}`}>
        <div className={Styles.privacyInner}>
          <header className={Styles.privacyHeader}>
            <span className={`${bm.eyebrow} ${Styles.privacyEyebrow}`}>Legal</span>
            <h1 className={Styles.privacyTitle}>Privacy statement</h1>
            <p className={Styles.privacyLead}>
              How MAGIC WAND EMPOWERMENT PVT LTD (Iron Lady) handles your information when you use our site and
              services.
            </p>
          </header>

          <div className={Styles.companyCard}>
            <div>MAGIC WAND EMPOWERMENT PVT LTD</div>
            <div>#73/42, 41st cross, 8th Block Jayanagar,</div>
            <div>Bangalore-560082, Karnataka, INDIA,</div>
            <div>Ph: (+91) 80 4120 9792</div>
            <div>CIN: U93000KA2011PTC060195</div>
            <div>
              Website:{" "}
              <a href="https://www.iamironlady.com" rel="noreferrer">
                www.iamironlady.com
              </a>
            </div>
            <div>
              Email:{" "}
              <a href="mailto:Connect@iamironlady.com">Connect@iamironlady.com</a>
            </div>
            <span className={Styles.tagline}>
              &ldquo;supporting women in developing breakthrough leadership capabilities&rdquo;
            </span>
          </div>

          <article className={Styles.prose}>
            <section>
              <h2 className={Styles.sectionTitle}>What do we do with your information?</h2>
              <p className={Styles.body}>
                When you purchase something from Iron Lady, as part of the buying and selling process, we collect the
                personal information you provide, such as your name, address, and email address. Additionally, when you
                browse our store, we automatically receive your computer&apos;s internet protocol (IP) address to
                gather information about your browser and operating system. With your permission, we may also send you
                emails about our store, new products, and other updates, which will safely be stored in our customer
                management system.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Consent</h2>
              <h3 className={Styles.subheading}>How do you get my consent?</h3>
              <p className={Styles.body}>
                By providing us with personal information to complete a transaction, verify your credit card, place an
                order, arrange for a delivery, or return a purchase, you imply consent for us to collect and use it for
                that specific reason only. If we require your personal information for secondary purposes like marketing,
                we will ask for your expressed consent directly or provide an opportunity for you to decline.
              </p>
              <h3 className={Styles.subheading}>How do I withdraw my consent?</h3>
              <p className={Styles.body}>
                If you change your mind after opting in, you may withdraw your consent at any time by contacting us at{" "}
                <a href="mailto:admin@iamironlady.com">admin@iamironlady.com</a> or mailing us at Iron Lady Office — NO
                643, 11TH MAIN, HAL 2ND STAGE, INDIRANAGAR, NEXT TO INDIRANAGAR CLUB, Bengaluru (Bangalore) Urban,
                Karnataka, 560038.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Disclosure</h2>
              <p className={Styles.body}>
                We may disclose your personal information if required by law or if you violate our Terms of Service.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Payment</h2>
              <p className={Styles.body}>
                We use Razorpay and Instamojo for processing payments, and they do not store your card data on their
                servers. Payment information is encrypted through the Payment Card Industry Data Security Standard
                (PCI-DSS). Your purchase transaction data is used only as long as necessary to complete the
                transaction, adhering to PCI-DSS standards for secure handling of credit card information.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Third-party services</h2>
              <p className={Styles.body}>
                While our third-party providers collect, use, and disclose information to perform services, certain
                providers have their own privacy policies. We recommend reading their policies to understand how your
                personal information will be handled. Once redirected to a third-party website, you are no longer
                governed by our Privacy Policy or Terms of Service.
              </p>
              <h3 className={Styles.subheading}>Links</h3>
              <p className={Styles.body}>
                Clicking on links on our store may direct you away from our site. We are not responsible for the privacy
                practices of other sites, so please read their privacy statements.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Security</h2>
              <p className={Styles.body}>
                To protect your personal information, we take reasonable precautions and follow industry best practices
                to prevent inappropriate access, disclosure, alteration, or destruction.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Cookies</h2>
              <p className={Styles.body}>
                We use cookies to maintain your user session but not to personally identify you on other websites.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Age of consent</h2>
              <p className={Styles.body}>
                By using this site, you affirm that you are at least the age of majority in your state or province of
                residence, or that you are the age of majority in your state or province of residence and you have given
                us your consent to allow any of your minor dependents to use this site.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Changes to this privacy policy</h2>
              <p className={Styles.body}>
                We reserve the right to modify this privacy policy at any time. Changes will take effect immediately upon
                posting on the website. Material changes will be notified to you. If our store is acquired or merged,
                your information may be transferred to the new owners.
              </p>
            </section>

            <section>
              <h2 className={Styles.sectionTitle}>Questions and contact information</h2>
              <p className={Styles.body}>
                If you wish to access, correct, amend, or delete personal information, register a complaint, or seek
                more information, contact our Privacy Compliance Officer at{" "}
                <a href="mailto:admin@iamironlady.com">admin@iamironlady.com</a> or by mail at Iron Lady Office — NO
                643, 11TH MAIN, HAL 2ND STAGE, INDIRANAGAR, NEXT TO INDIRANAGAR CLUB, Bengaluru (Bangalore) Urban,
                Karnataka, 560038.
              </p>
            </section>
          </article>
        </div>
      </section>
    </div>
  );
}
